import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

function generateClassname(prefix, value) {
  if (value) {
    return prefix + value;
  }
  return null;
}

const Col = ({xs, sm, md, lg, xsOffset, smOffset, mdOffset, lgOffset, children, style, className}) => {
  const classes = classNames(
    generateClassname('col-xs-', xs),
    generateClassname('col-sm-', sm),
    generateClassname('col-md-', md),
    generateClassname('col-lg-', lg),
    generateClassname('col-xs-offset-', xsOffset),
    generateClassname('col-sm-offset-', smOffset),
    generateClassname('col-md-offset-', mdOffset),
    generateClassname('col-lg-offset-', lgOffset),
    className);

  return <div className={classes} style={style}>
    {children}
  </div>;
};

Col.propTypes = {
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  xsOffset: PropTypes.number,
  smOffset: PropTypes.number,
  mdOffset: PropTypes.number,
  lgOffset: PropTypes.number,
  children: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default Col;
